<template>
  <div>
    <router-view class="view" keep-alive transition transition-mode="out-in" />
    <page-listar v-if="isIndexOnly()" />
  </div>
</template>

<script>
import Historico from './Historico'

export default {
  name: 'mensagem-config',
  data () {
    return {
      title: 'Envio de Mensagens p/ Motoristas'
    }
  },
  components: {
    'page-listar': Historico
  },
  methods: {
    isIndexOnly () {
      return this.$router.currentRoute.path === '/mensagens' || this.$router.currentRoute.path === '/mensagens/'
    }
  },
  mounted () {
    this.$parent.$data.title = this.title
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/mensagens/index.vue